import {
  LayoutDashboard,
  BarChart2,
  CheckSquare,
  Calendar,
  Bell,
  Radio,
  BookMarked,
  Target,
  Users,
  Unplug,
  Library,
  Sparkles,
  Bot,
  ScrollText,
  LineChart,
  FileText,
  ExternalLink,
  Home,
  Lightbulb,
  Mail,
  Database,
  FolderOpen,
  NotebookPen,
  ShieldCheck,
  Search,
  Book,
  Plug,
  Key,
  Wrench,
  FlaskConical,
  Gauge,
  Settings2,
} from 'lucide-react'

/** Sidebar nav sections for main shell and admin panel. */

export const DASHBOARD_HOME_NAV = [{ id: 'platform-overview', label: 'Dashboard', Icon: Home }]

/** Admin — unified Knowledge Base (Search lives on main shell) */
export const DASHBOARD_KNOWLEDGE_NAV = [
  { id: 'knowledge-base:dashboard', label: 'Overview', Icon: Database },
  { id: 'knowledge-base:content', label: 'Library', Icon: FolderOpen },
  { id: 'knowledge-base:wiki', label: 'Wiki', Icon: Book },
  { id: 'knowledge-base:access', label: 'Access', Icon: ShieldCheck },
]

/** Admin — KB developer / pipeline tools (same routes, query tabs) */
export const DASHBOARD_DEV_TOOLS_NAV = [
  { id: 'kb-dev-playground', label: 'Search playground', Icon: FlaskConical },
  { id: 'kb-dev-settings', label: 'Pipeline settings', Icon: Settings2 },
  { id: 'kb-dev-eval', label: 'Search eval', Icon: BarChart2 },
  { id: 'kb-dev-latency', label: 'Query latency', Icon: Gauge },
]

/** Admin — MCP Server (external LLM gateway) */
export const DASHBOARD_MCP_NAV = [
  { id: 'mcp-server:overview', label: 'Overview', Icon: Plug },
  { id: 'mcp-server:keys', label: 'API Keys', Icon: Key },
  { id: 'mcp-server:tools', label: 'Tools', Icon: Wrench },
  { id: 'mcp-server:logs', label: 'Logs', Icon: ScrollText },
]

/** Main shell — run pipeline stages (below Dashboard, above Main). */
export const DASHBOARD_AGENTS_NAV = [{ id: 'agents', label: 'Agents', Icon: Bot }]

/** Main shell — Knowledge Search (below Agents, above Main). */
export const DASHBOARD_KNOWLEDGE_SEARCH_NAV = [
  { id: 'knowledge-search', label: 'Knowledge Search', Icon: Search },
]

export const ADMIN_AGENTS_SETTINGS_PATH = '/admin/agents-settings'

export const DASHBOARD_BASECAMP_NAV = [
  { id: 'basecamp-knowledge', label: 'Basecamp KB', Icon: Library },
  { id: 'basecamp-projects', label: 'Basecamp Projects-Client Mapping', Icon: Sparkles },
]

export const DASHBOARD_MAIN_NAV = [
  { id: 'clients', label: 'Client Dashboard', Icon: LayoutDashboard },
  { id: 'analytics', label: 'Analytics', Icon: BarChart2 },
  { id: 'elections', label: 'Election Data', Icon: CheckSquare },
  { id: 'primary-calendar', label: 'Primary Calendar', Icon: Calendar, hidden: true },
  { id: 'adimpact-alerts', label: 'Client AdImpact Alerts', Icon: Bell },
  { id: 'big-political-list', label: 'Big Political List', Icon: Radio },
  { id: 'resources', label: 'Resources', Icon: BookMarked },
  { id: 'race-tracker', label: 'Race Tracker ', Icon: Target },
  { id: 'idea-board', label: 'Idea Board', Icon: Lightbulb },
]

export const DASHBOARD_INTERNAL_APPS_NAV = [
  { id: 'ad-ops-hq', label: 'Ad Ops HQ', Icon: ExternalLink, href: 'https://admin-smg.dagnyrails.com/' },
  { id: 'rate-auditing', label: 'Rate Auditing', Icon: ExternalLink, href: 'https://audit-smg.dagnyrails.com/' },
  { id: 'command-center', label: 'Command Center', Icon: ExternalLink, href: 'https://hq.smartmediagroup.com/' },
]

export const DASHBOARD_MAIN_SHELL_NAV = [...DASHBOARD_MAIN_NAV, ...DASHBOARD_INTERNAL_APPS_NAV]

export const DASHBOARD_AI_NAV = [
  { id: 'ai-agents', label: 'Agents Setting', Icon: Bot },
  { id: 'ai-agents-logs', label: 'Agents Logs', Icon: ScrollText },
  { id: 'ai-cost-monitoring', label: 'Cost and Monitoring', Icon: LineChart, superAdminOnly: true },
]

export const DASHBOARD_OUTLOOK_NAV = [{ id: 'outlook', label: 'Outlook', Icon: Mail }]

export const DASHBOARD_SHAREPOINT_NAV = [{ id: 'sharepoints', label: 'SharePoint', Icon: FolderOpen }]

export const DASHBOARD_ONENOTE_NAV = [{ id: 'onenotes', label: 'OneNote', Icon: NotebookPen }]

export const DASHBOARD_DOCUMENTATION_NAV = [
  { id: 'technical-documentation', label: 'App documentation', Icon: FileText },
]

export const DASHBOARD_ADMIN_NAV = [
  { id: 'settings-users', label: 'User Management', Icon: Users },
  { id: 'settings-integrations', label: 'Integrations', Icon: Unplug },
]

/** Admin sidebar sections in landing-priority order (Documentation last) */
export const ADMIN_NAV_SECTIONS = [
  DASHBOARD_KNOWLEDGE_NAV,
  DASHBOARD_DEV_TOOLS_NAV,
  DASHBOARD_MCP_NAV,
  DASHBOARD_BASECAMP_NAV,
  DASHBOARD_AI_NAV,
  DASHBOARD_OUTLOOK_NAV,
  DASHBOARD_SHAREPOINT_NAV,
  DASHBOARD_ONENOTE_NAV,
  DASHBOARD_ADMIN_NAV,
  DASHBOARD_DOCUMENTATION_NAV,
]

/** Section titles for admin sidebar collapsible groups */
export const ADMIN_SECTION_TITLES = {
  knowledge: 'Knowledge Base',
  devTools: 'Developer Tools',
  mcp: 'MCP Server',
  basecamp: 'Basecamp',
  ai: 'AI',
  outlook: 'Outlook',
  sharepoint: 'SharePoint',
  onenote: 'OneNote',
  admin: 'Administration',
  documentation: 'Documentation',
}

const ADMIN_PATH_BY_ID = {
  'knowledge-base:dashboard': '/admin/knowledge/dashboard',
  'knowledge-base:content': '/admin/knowledge/content',
  'knowledge-base:wiki': '/admin/knowledge/wiki',
  'knowledge-base:access': '/admin/knowledge/access?tab=permissions',
  'kb-dev-playground': '/admin/knowledge/access?tab=playground',
  'kb-dev-settings': '/admin/knowledge/access?tab=settings',
  'kb-dev-eval': '/admin/knowledge/access?tab=eval',
  'kb-dev-latency': '/admin/knowledge/access?tab=latency',
  'mcp-server:overview': '/admin/mcp/overview',
  'mcp-server:keys': '/admin/mcp/keys',
  'mcp-server:tools': '/admin/mcp/tools',
  'mcp-server:logs': '/admin/mcp/logs',
  'settings-users': '/admin/users',
  'settings-integrations': '/admin/integrations',
  'basecamp-api-references': '/admin/basecamp-api-references',
  'technical-documentation': '/admin/technical-documentation',
  'basecamp-knowledge': '/admin/basecamp/knowledge',
  'basecamp-projects': '/admin/basecamp/projects',
  'ai-agents': ADMIN_AGENTS_SETTINGS_PATH,
  'ai-agents-logs': '/admin/ai/agents-logs',
  'ai-cost-monitoring': '/admin/ai/cost-monitoring',
  outlook: '/admin/outlook',
  sharepoints: '/admin/sharepoint',
  onenotes: '/admin/onenote',
}

/**
 * Map sidebar nav id to RBAC page key for access checks.
 * @param {string} navId
 */
export function resolveAdminNavPageKey(navId) {
  if (navId.startsWith('kb-dev-')) return 'knowledge-base:access'
  return navId
}

/**
 * @param {(pageKey: string) => boolean} canAccessPage
 * @returns {string | null}
 */
export function getFirstAccessibleAdminPath(canAccessPage) {
  for (const section of ADMIN_NAV_SECTIONS) {
    for (const item of section) {
      const { id } = item
      const pageKey = resolveAdminNavPageKey(id)
      if (canAccessPage(pageKey) && ADMIN_PATH_BY_ID[id]) {
        return ADMIN_PATH_BY_ID[id]
      }
    }
  }
  return null
}

/**
 * @param {(pageKey: string) => boolean} canAccessPage
 * @returns {boolean}
 */
export function canAccessAnyAdminArea(canAccessPage) {
  return ADMIN_NAV_SECTIONS.some((section) =>
    section.some((n) => canAccessPage(resolveAdminNavPageKey(n.id)))
  )
}
